import { useJsApiLoader, GoogleMap, Marker } from '@react-google-maps/api'

const mapOptions = { 
  streetViewControl: false,
  scrollwheel: false,
  fullscreenControl: false,
}

const containerStyle = {
  width: '100%',
  height: '400px'
};

interface MapGoogleProps {
  location: { latitude: number, longitude: number }
}

const Map = ({ location }: MapGoogleProps) => {
  const { isLoaded }= useJsApiLoader({
    googleMapsApiKey: String(process.env.REACT_APP_GOOGLE_MAPS_KEY),
  })

  if (!isLoaded) return <></>

  return (
    <GoogleMap options={mapOptions} zoom={14} center={{ lat: location.latitude, lng: location.longitude }} mapContainerStyle={containerStyle}>
      <Marker position={{ lat: location.latitude, lng: location.longitude }}></Marker>
    </GoogleMap>
  ) 
}

export { Map }